
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { Checklist, Lead, User } from '@/types';
import LeadChecklistTitle from '@/components/LeadChecklistTitle.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import API from '@/lib/API';

@Component({
  components: {
    LeadChecklistTitle,
    ConfirmDialog,
  },
})
export default class LeadChecklist extends Vue {
  @Prop(Boolean) readonly loading!: boolean
  @Prop(Object) readonly checklist!: Checklist

  updating = false
  removing = false
  confirmDialog = false
  confirmOptions = {
    title: 'Rimuovi Checklist',
    text: '',
    question: 'Vuoi procedere con la rimozione?',
    yesText: 'Sì, rimuovi',
    noText: 'Annulla',
  }

  // Mantiene traccia dei task in aggiornamento per evitare di bloccare tutta la lista
  updatingTaskIds: number[] = []

  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  get checklists(): Checklist[] {
    return this.lead && Array.isArray(this.lead.checklists) && this.lead.checklists.length > 0
      ? this.lead.checklists
      : [];
  }

  get checklistComplete() {
    // eslint-disable-next-line no-restricted-syntax
    for (const task of this.checklist.tasks) {
      if (task.status !== 'completed') {
        return false;
      }
    }

    return true;
  }

  get taskClass() {
    return this.checklistComplete ? 'completed' : '';
  }

  get expansionPanelClass() {
    return this.checklistComplete ? '' : 'todo';
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get isSuperUser(): boolean {
    return this.user && this.user.isSuperUser;
  }

  // taskRowClass(task) {
  //   if (task.status === null
  //     && task.relationship === 'father'
  //     && this.hasPermission(`leads_${this.lead.type}.task_child`)) {
  //     return `${task.name} child`;
  //   }

  //   // Se il task è padre e la lead figlia è chiusa...
  //   if (task.relationship === 'father'
  //     && this.childLeads
  //     && this.childLeads.hasOwnProperty(task.childLeadId)
  //     && this.childLeads[task.childLeadId].status === 'closed') {
  //     return `${task.name} child`;
  //   }

  //   return UTILS.taskRowClass(task);
  // }

  isTaskUpdating(taskId: number): boolean {
    return this.updatingTaskIds.includes(taskId);
  }

  async selectTask(task) {
    if (this.lead.status !== 'open') return false;
    if (this.isTaskUpdating(task.id)) return false;

    this.updatingTaskIds.push(task.id);

    try {
      await this.$store.dispatch('updateLead', {
        updateType: 'task',
        update: {
          task,
          status: task.status === 'completed' ? null : 'completed',
        },
      });
    } finally {
      this.updatingTaskIds = this.updatingTaskIds.filter((id) => id !== task.id);
    }

    return false;
  }

  onRemoveClick() {
    this.confirmOptions.text = `Stai per rimuovere definitivamente la checklist "${this.checklist.name}" da questa lead.`;
    this.confirmDialog = true;
  }

  async onConfirmRemove() {
    this.removing = true;

    try {
      await API.removeLeadChecklist(this.lead.id, this.checklist.id);

      // Aggiorna la lead corrente
      await this.$store.dispatch('refreshLead');
    } catch (error) {
      console.error('Errore durante la rimozione della checklist:', error);
    } finally {
      this.removing = false;
      this.confirmDialog = false;
    }
  }
}
